import { render } from "./ProductDetail.vue?vue&type=template&id=e87751f8"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script